import { Typography, Grid, Box, TextField } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IdCardImg from '../../../../Assets/IdcardImg.png';
import KenButton from '../../../../GlobalComponents/KenButton';
import { useStyles } from '../../style';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { lg: '35vw', md: '35vw', xl: '35vw' },
  bgcolor: 'background.paper',
  border: '2px solid white',
  boxShadow: 24,
  borderRadius: 2,
  p: { xs: 2, sm: 2, md: 4, lg: 4, xl: 4 },
};

const LinkedInModel = (props: any) => {
  const classes = useStyles();
  return (
    <div>
      <Box sx={style}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography sx={{ fontWeight: '500', fontSize: '12px' }}>LinkedIn Profile</Typography>
          </Grid>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end', cursor: 'pointer' }}>
            <CloseIcon onClick={props.handleClose} sx={{ fontSize: '15px' }} />
          </Grid>
        </Grid>
        <hr style={{ border: '1px solid #E6E6E8' }} />
        <Box sx={{ mt: 2 }}>
          <Typography sx={{ mt: 2, fontWeight: '500', fontSize: '10px' }}>Enter your LinkedIn URL</Typography>
          <TextField
            sx={{
              mt: 2,
              '& .MuiOutlinedInput-root': {
                height: '36px',
                fontSize: '12px',
              },
              '& .MuiInputLabel-root': {
                fontSize: '12px',
              },
              '& .MuiInputLabel-shrink': {
                fontSize: '12px',
              },
            }}
            id="outlined-basic"
            label="www.linkedin.com/in/username"
            variant="outlined"
            fullWidth
            size="small"
          />
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={6} />
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
              <KenButton
                variant="text"
                className={classes.button}
                sx={{
                  borderRadius: '8px',
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                }}
                fullWidth
                onClick={props.handleClose}
              >
                <Typography sx={{ color: '#373A45', fontSize: '10px', fontWeight: '500' }}>Cancel</Typography>
              </KenButton>
              <KenButton variant="contained" className={classes.button} style={{ borderRadius: '8px', boxShadow: 'none' }} fullWidth onClick={props.handleClose}>
                <Typography sx={{ fontSize: '10px', fontWeight: '500' }}>Save</Typography>
              </KenButton>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default LinkedInModel;
